import { cn } from "@/utils/cn";

export default function NurseRowGrid({
  nurseId,
  isRowSelected,
  isPinnedRowSelected,
  isRowHovered,
  roleGroupBottomBorder,
  dispatchGroupTopBorder = false,
  children,
}: {
  nurseId: string;
  isRowSelected: boolean;
  isPinnedRowSelected: boolean;
  isRowHovered: boolean;
  roleGroupBottomBorder: boolean;
  dispatchGroupTopBorder?: boolean;
  children: React.ReactNode;
}) {
  return (
    <div
      data-nurse-id={nurseId}
      data-nurse-row-id={nurseId}
      data-memo-focused={isPinnedRowSelected || undefined}
      className={cn(
        "relative flex w-full min-w-0 items-stretch",
        isPinnedRowSelected
          ? "bg-[#F1F7FF] before:absolute before:inset-y-0 before:left-0 before:z-10 before:w-[3px] before:bg-sig"
          : isRowSelected
            ? "bg-[#D4F0FF]"
            : isRowHovered
              ? "bg-[#e3f5ff]"
              : "",
        dispatchGroupTopBorder && "border-t border-[#D6D6DE]",
        roleGroupBottomBorder && "border-b border-[#D6D6DE]"
      )}
    >
      {children}
    </div>
  );
}
